import { isWeb } from '../../utils/platformUtils'
import { openDB } from '../indexDB'
import { POST_TABLE_NAMES } from '../constants'
import { PostsServices } from '../../../database/posts.database'

export const update_like_post_app = async (db, post_id, value) => {
    try {
        if (isWeb()) {
            // Web implementation stays the same
            return update_like_post_web(db, post_id, value)
        } else {
            // SQLite SDK 54 implementation
            const statement = db.prepareSync(`UPDATE ${POST_TABLE_NAMES.POSTS} SET reaction_counter = ? WHERE _id = ?`)
            statement.executeSync([value, post_id])
            statement.finalizeSync()
        }
    } catch (error) {
        console.error('Error en la actualización del contenido:', error)
        throw error
    }
}

export const update_like_post_web = (db, post_id, value) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([POST_TABLE_NAMES.POSTS], 'readwrite')
            const objectStore = transaction.objectStore(POST_TABLE_NAMES.POSTS)

            const getRequest = objectStore.get(post_id)

            getRequest.onsuccess = (event) => {
                const isExistsPost = event.target.result

                if (isExistsPost) {
                    isExistsPost.reaction_counter = value

                    const putRequest = objectStore.put(isExistsPost)

                    putRequest.onsuccess = () => {
                        resolve()
                    }

                    putRequest.onerror = (event) => {
                        reject(event.target.error)
                    }
                } else {
                    resolve() // Post doesn't exist, nothing to update
                }
            }

            getRequest.onerror = (event) => {
                reject(event.target.error)
            }
        })
    }
}

export const update_favourite_post_app = async (db, post_id, value) => {
    try {
        if (isWeb()) {
            // Web implementation
            const transaction = db.transaction([POST_TABLE_NAMES.POSTS], 'readwrite')
            const objectStore = transaction.objectStore(POST_TABLE_NAMES.POSTS)

            return new Promise((resolve, reject) => {
                const getRequest = objectStore.get(post_id)

                getRequest.onsuccess = (event) => {
                    const isExistsPost = event.target.result

                    if (isExistsPost) {
                        isExistsPost.status_favourite = value

                        const putRequest = objectStore.put(isExistsPost)

                        putRequest.onsuccess = () => {
                            resolve()
                        }

                        putRequest.onerror = (event) => {
                            reject(event.target.error)
                        }
                    } else {
                        resolve()
                    }
                }

                getRequest.onerror = (event) => {
                    reject(event.target.error)
                }
            })
        } else {
            // SQLite SDK 54 implementation
            const statement = db.prepareSync(`UPDATE ${POST_TABLE_NAMES.POSTS} SET status_favourite = ? WHERE _id = ?`)
            statement.executeSync([value, post_id])
            statement.finalizeSync()
        }
    } catch (error) {
        console.error('Error updating favourite post:', error)
        throw error
    }
}

export const update_views_post = async (db, post_id, value) => {
    try {
        if (isWeb()) {
            // Web implementation
            const transaction = db.transaction([POST_TABLE_NAMES.POSTS], 'readwrite')
            const objectStore = transaction.objectStore(POST_TABLE_NAMES.POSTS)

            return new Promise((resolve, reject) => {
                const getRequest = objectStore.get(post_id)

                getRequest.onsuccess = (event) => {
                    const isExistsPost = event.target.result

                    if (isExistsPost) {
                        isExistsPost.views = value

                        const putRequest = objectStore.put(isExistsPost)

                        putRequest.onsuccess = () => {
                            resolve()
                        }

                        putRequest.onerror = (event) => {
                            reject(event.target.error)
                        }
                    } else {
                        resolve()
                    }
                }

                getRequest.onerror = (event) => {
                    reject(event.target.error)
                }
            })
        } else {
            // SQLite SDK 54 implementation
            const statement = db.prepareSync(`UPDATE ${POST_TABLE_NAMES.POSTS} SET views = ? WHERE _id = ?`)
            statement.executeSync([value, post_id])
            statement.finalizeSync()
        }
    } catch (error) {
        console.error('Error updating post views:', error)
        throw error
    }
}

export const get_posts_by_label = (db, label) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            const transaction = db.transaction([POST_TABLE_NAMES.POSTS], 'readonly')
            const objectStore = transaction.objectStore(POST_TABLE_NAMES.POSTS)
            const request = objectStore.getAll()

            request.onsuccess = (event) => {
                const posts = event.target.result
                const filteredPosts = posts.filter((post) => post.labels && post.labels.includes(label))
                resolve(filteredPosts)
            }

            request.onerror = (event) => {
                reject(event.target.error)
            }
        } else {
            try {
                const statement = db.prepareSync(`SELECT * FROM ${POST_TABLE_NAMES.POSTS} WHERE labels LIKE ?`)
                const result = statement.executeSync([`%${label}%`])
                const posts = result.getAllSync()
                statement.finalizeSync()
                resolve(posts)
            } catch (error) {
                console.error('Error getting posts by label:', error)
                reject(error)
            }
        }
    })
}

// Viewed posts functionality
export const get_viewed_posts = (db) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            try {
                const transaction = db.transaction([POST_TABLE_NAMES.VIEWED_POSTS], 'readonly')
                const objectStore = transaction.objectStore(POST_TABLE_NAMES.VIEWED_POSTS)
                const request = objectStore.getAll()
                request.onsuccess = (event) => resolve(event.target.result || [])
                request.onerror = (event) => reject(event.target.error)
            } catch (e) {
                console.error('get_viewed_posts (web) error:', e)
                resolve([])
            }
        } else {
            try {
                const stmt = db.prepareSync(`SELECT * FROM ${POST_TABLE_NAMES.VIEWED_POSTS} ORDER BY date DESC`)
                const rows = stmt.getAllSync([])
                stmt.finalizeSync()
                resolve(rows)
            } catch (e) {
                console.error('get_viewed_posts (sqlite) error:', e)
                resolve([])
            }
        }
    })
}

export const add_viewed_post = (db, postId) => {
    return new Promise((resolve, reject) => {
        if (isWeb()) {
            try {
                const transaction = db.transaction([POST_TABLE_NAMES.VIEWED_POSTS], 'readwrite')
                const objectStore = transaction.objectStore(POST_TABLE_NAMES.VIEWED_POSTS)
                const addReq = objectStore.add({ _id: postId, date: new Date().toISOString() })
                addReq.onsuccess = () => resolve()
                addReq.onerror = (event) => {
                    // Si ya existe, consideramos OK
                    console.warn('add_viewed_post (web) duplicate or error:', event.target.error)
                    resolve()
                }
            } catch (e) {
                console.error('add_viewed_post (web) error:', e)
                resolve()
            }
        } else {
            try {
                const check = db.prepareSync(`SELECT COUNT(*) as count FROM ${POST_TABLE_NAMES.VIEWED_POSTS} WHERE _id = ?`)
                const row = check.getFirstSync([postId]) || { count: 0 }
                check.finalizeSync()
                if ((row.count || 0) > 0) return resolve()

                const insert = db.prepareSync(`INSERT INTO ${POST_TABLE_NAMES.VIEWED_POSTS} (_id, date) VALUES (?, ?)`)
                insert.executeSync([postId, new Date().toISOString()])
                insert.finalizeSync()
                resolve()
            } catch (e) {
                console.error('add_viewed_post (sqlite) error:', e)
                resolve()
            }
        }
    })
}

// --- Compatibility helpers for UI imports ---
export const update_like_local_posts = async (post_id, count) => {
    // no-op stub to satisfy imports; real local persistence not required for migration
    return true
}

export const update_favourite_local_posts = async (post_id, value) => {
    try {
        // updateo web y apps
        if (isWeb()) {
            console.log('no function update_favourite_post_web en web')
            return true
        } else {
            console.log('update_favourite_local_posts', value)
            await PostsServices.update_favourite_post_app(post_id, JSON.stringify(value))
        }
    } catch (error) {
        console.error('Error updating favourite local posts:', error)
    }
}

export const update_complete_local_posts = async (post_id, value) => {
    return true
}

export const get_post_by_id = async (db, id) => {
    if (isWeb()) {
        return new Promise((resolve, reject) => {
            const transaction = db.transaction([POST_TABLE_NAMES.POSTS], 'readonly')
            const objectStore = transaction.objectStore(POST_TABLE_NAMES.POSTS)
            const getRequest = objectStore.get(id)
            getRequest.onsuccess = (e) => resolve(e.target.result || null)
            getRequest.onerror = (e) => reject(e.target.error)
        })
    } else {
        try {
            const statement = db.prepareSync(`SELECT * FROM ${POST_TABLE_NAMES.POSTS} WHERE _id = ?`)
            const result = statement.executeSync([id])
            const post = result.getFirstSync()
            statement.finalizeSync()
            return post || null
        } catch (error) {
            console.error('Error getting post by id:', error)
            return null
        }
    }
}
